// extracted by mini-css-extract-plugin
module.exports = {"container":"Feature-module--container--f524X","feature":"Feature-module--feature--32xNI","mirrored":"Feature-module--mirrored--2e0Yv"};